import {
    DELETE_AMENITY_FAILURE, DELETE_AMENITY_REQUEST, DELETE_AMENITY_SUCCESS,
     GET_AMENITY_FAILURE, GET_AMENITY_REQUEST, GET_AMENITY_SUCCESS, 
     POST_AMENITY_FAILURE, POST_AMENITY_REQUEST,POST_AMENITY_SUCCESS,
     PUT_AMENITY_FAILURE, PUT_AMENITY_REQUEST,PUT_AMENITY_SUCCESS
  } from "../../../Utils/Constant";
  
  const initialState = {
    allAmenities: [],
    newAmenity: {},
    addAmenities:{},
    updateAmenities:{}, 
    deleteAmnities:{},        
    loading: false,     
    error: null,       
  };
  
  export const amenityReducer = (state = initialState, action) => {
    switch (action.type) {
      // GET amenity
      case GET_AMENITY_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
        };
      case GET_AMENITY_SUCCESS:
        return {
          ...state,
          allAmenities: action.payload,
          loading: false,
          error: null,
        };
      case GET_AMENITY_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
  
      // POST amenity
      case POST_AMENITY_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
        };
      case POST_AMENITY_SUCCESS:
        return {
          ...state,
          addAmenities: action.payload,
          loading: false,
          error: null,
        };
      case POST_AMENITY_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
        // update
        case PUT_AMENITY_REQUEST:
          return {
            ...state,
            loading: true,
            error: null,
          };
        case PUT_AMENITY_SUCCESS:
          return {
            ...state,
            updateAmenities: action.payload,
            loading: false,
            error: null,
          };
        case PUT_AMENITY_FAILURE:
          return {
            ...state,
            loading: false,
            error: action.payload,
          };
  
    // DELETE amenity
    case DELETE_AMENITY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case DELETE_AMENITY_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case DELETE_AMENITY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
  
      default:
        return state;
    }
  };
  